module.exports = __webpack_public_path__ + "media/images/athletes/4142-82aff09a6ad95b0a0e56faeb62a7bc2f.png";